<template>
  <p :class="inputError ? `a-input-wrapper-column a-input-tinymce-danger ${wrapperClass}` : `a-input-wrapper-column ${wrapperClass}`">
    <label
      v-if="label"
      :for="$attrs.name"
    >
      {{ label }}
    </label>
    <editor
      :value="value"
      v-bind="$attrs"
      :init="tinyMceInit"
      v-on="listeners"
      @input="updateValue"
    >
    </editor>
    <small
      v-if="!inputError && message"
      class="font-weight-light"
    >
      <i>{{ message }}</i>
    </small>
    <small
      v-if="inputError"
      class="text-color-danger"
    >
      {{ messageError }}
    </small>
  </p>
</template>

<script>
export default {
  name: 'AtomTinymcePrimary',

  components: {
    Editor: () => import('@tinymce/tinymce-vue')
  },

  inheritAttrs: false,

  props: {
    inputError: Boolean,
    label: String,
    message: String,
    messageError: String,
    value: [Number, String],
    wrapperClass: String
  },

  data () {
    return {
      // TODO: leer valores de language_url y language en base al idioma seleccionado
      tinyMceInit: {
        branding: false,
        height: 325,
        language_url: `/tinymce/js/tinymce/langs/es.js`,
        language: 'es_ES',
        menubar: false,

        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code'
        ],

        toolbar: 'undo redo | formatselect | bold italic underline strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent table removeformat',
        content_style: 'body, td, pre { color: rgba(0, 0, 0, 0.80); font-family: \'Open Sans\', sans-serif; font-size: 16px; margin: 10px; }'
      }
    }
  },

  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: this.updateValue
      }
    }
  },

  methods: {
    updateValue (event) {
      this.$emit('input', event)
    }
  }
}
</script>
